export function isUnlimitedTariffLimit(value) {
    return Number(value) === -1;
}

export function hasUnlimitedActiveTariff(tariffs) {
    return (Array.isArray(tariffs) ? tariffs : []).some(
        (tariff) => tariff?.is_active === true && isUnlimitedTariffLimit(tariff?.maxLeadsCount)
    );
}
